import { fetchConfig } from '../common'

// UMG Gift With Purchase Functionality

export function UmgGwp (cartUI, sections, sections_url) {
  if (window.umgGwp === undefined) {
    return
  }
  const gwp = window.umgGwp
  const config = gwp.config
  const spendProducts = gwp.spendProducts
  const getProducts = gwp.getProducts

  fetchCart().then(data => {
    const itemAlreadyInCart = isGwpItemInCart(data, getProducts)
    const shouldAdd = shouldGwpItemBeAddedAutomatically(data, config, spendProducts)

    if (itemAlreadyInCart) {
      if (!shouldAdd) {
        removeGwpItem(data, config, getProducts, cartUI, sections, sections_url)
      }
    } else if (shouldAdd) {
      addGwpItem(cartUI, sections, sections_url)
    }
  })
}

async function fetchCart () {
  const response = await fetch('/cart.js')
  const data = await response.json()
  return data
}

function isGwpItemInCart (cartData, getProducts) {
  // Checking if GWP item is already in cart
  const cartItems = cartData.items
  for (let i = 0; i < cartItems.length; i++) {
    const item = cartItems[i]
    for (let j = 0; j < getProducts.length; j++) {
      const getProduct = getProducts[j]
      if (item.product_id === getProduct) {
        return true
      }
    }
  }
  return false
}

function shouldGwpItemBeAddedAutomatically (cartData, config, spendProducts) {
  // Keep all Business Logic for Different Types of GWP here

  if (config.autoAddToCart !== true) {
    // Return false if config is set to not auto add to cart
    return false
    // TODO:? add support for checking if item is free, and return false if not, as those are then paid items and shouldn't add to cart automatically?
  }

  // Spend X, Get Y, eg Spent $50, get Sticker automatically added to cart
  if (config.type === 'spendXGetY') {
    // GWP only automatic currently for when specific products are added to cart
    if (config.spendBehaviour.itemsFrom === 'specificProducts') {
      let currentCartRequiredItemsValue = 0
      const cartItems = cartData.items
      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i]
        // only increase current cart value if item in cart is part of required items
        if (spendProducts.includes(item.product_id)) {
          currentCartRequiredItemsValue = currentCartRequiredItemsValue + item.final_line_price
        }
      }

      // calculate minimum value spend needed for stores with multiple currencies
      const minValueSpend = parseFloat(Shopify.currency.rate) * parseFloat(config.spendBehaviour.minValueBaseCurrency)
      // only return true if current cart value of eligible items is more than the minimum value required
      if (currentCartRequiredItemsValue >= minValueSpend) {
        return true
      }
      return false
    }
  }

  return false
}

function removeGwpItem (cartData, config, getProducts, cartUI, sections, sections_url) {
  // Stop auto remove, if not set to true
  if (config.autoRemoveFromCart !== true) {
    return
  }
  const cartItems = cartData.items
  let itemToRemove

  // Checking if GWP should be removed
  for (let i = 0; i < cartItems.length; i++) {
    const item = cartItems[i]
    for (let j = 0; j < getProducts.length; j++) {
      const getProduct = getProducts[j]
      if (item.product_id === getProduct) {
        // Remove GWP item
        itemToRemove = item.variant_id
        // Remove by variant rather than line, in case someone has tried to add it via other methods
        break
      }
    }
  }

  const body = JSON.stringify({
    id: `${itemToRemove}`,
    quantity: 0,
    sections: sections,
    sections_url: sections_url,
    selector: '.shopify-section'
  })

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.json()
    })
    .then((parsedState) => {
      if (parsedState.errors !== undefined) {
        // no way to handle errors at the moment, and no notifications to display errors
      } else {
        // cart renderContents is the same for cart drawer and cart page here (from original code)
        cartUI.renderContents(parsedState)
        // Don't need PDP, as not coming from standard add to cart event. that will go through product-form.js
      }
    }).catch((errors) => {
      // console.error('errors', errors)
      // Don't have PDP to display errors
    }).finally(() => {
      // Don't have PDP to refresh
    })
}

function addGwpItem (cartUI, sections, sections_url) {
  const fetchRequestConfig = fetchConfig('javascript')
  fetchRequestConfig.headers['X-Requested-With'] = 'XMLHttpRequest'
  delete fetchRequestConfig.headers['Content-Type']

  // this.has_cart_error = false

  const gwpProductForm = document.querySelector('#gwp-product')
  const gwpProductFormElement = gwpProductForm.querySelector('form')

  const formData = new FormData(gwpProductFormElement)

  formData.append('quantity', 1)
  formData.append('sections', sections)
  formData.append('sections_url', sections_url)

  fetchRequestConfig.body = formData

  fetch(`${routes.cart_add_url}`, fetchRequestConfig)
    .then((response) => response.json())
    .then((parsedState) => {
      // Purchase Limit Exceeded
      if (parsedState.status === 422) {
        // TODO: what sort of error do we display? do we display any?
        // How do we display any errors on theme side? if item exists in cart, we don't try to re-add it, so how would someone add multiple?

        // handlePurchaseLimitErrors(product_data, parsedState)
      // Add to Cart Successful
      } else {
        if (cartUI != null) {
          if (cartUI.classList.contains('cart-drawer')) {
            // re-render cart drawer
            cartUI.renderContents(parsedState, true, false)
          } else {
            cartUI.renderContents(parsedState)
          }
        }
        // Should have no quantity spinners to re-render
      }
    })
    .catch((errors) => {
      // console.error('error', errors)
      // Don't currently have anywhere to display errors for this add to cart
    })
    .finally(() => {
      // update pdp
      // not coming via standard add to cart, and shouldn't need to affect the PDP
    })
}
